import { formatDecimalAspectRatio } from '@/libs'
import { SelectItem } from '@dashboard/ui'

export const IMAGE_RATIO_OPTIONS: SelectItem[] = [
  1,
  3 / 2,
  5 / 2,
  7 / 5,
  10 / 8,
  16 / 9,
  2 / 3,
  2 / 5,
  5 / 7,
  8 / 10,
  9 / 16,
].map(aspectRatio => ({
  value: aspectRatio,
  children: formatDecimalAspectRatio(aspectRatio),
}))
